export { type ClickHouseClient, connect, createClickHouseClient } from './client.js'

export { ensureBinary, getInstallPaths } from './install.js'

export { isServerRunning, startServer, stopServer, waitForReady } from './server.js'

export type {
  DaemonClientOptions,
  DaemonInstallOptions,
  DaemonServerOptions,
  ServerStatusResult,
  WaitForReadyOptions,
} from './types.js'
